import * as React from "react";

interface Props {
    type: string,
    icon?: string,
    name?: string,
    placeholder?: string,
    label?: string,
    height?: string,
    required?: boolean,
    className?: string,
    value?: any,
    onChange?: any,
    index?: number
}

interface State {
    value: any
}

export default class FormInput extends React.Component<Props, State> {
    name: string;

    constructor(props) {
        super(props);

        this.name = this.getName();
        this.state = {
            value: this.props.value
        }
    }

    getName() {
        if(this.props.name)
            return this.props.name;

        if(this.props.label)
            return this.props.label.toLowerCase();

        let rnd = Math.floor(Math.random() * 999999) + 1;

        return "form-input-text-" + rnd;
    }

    getLabel() {
        return this.props.label ?
            <label className={"label_input"} htmlFor={this.name}>{this.props.label}
                { this.props.required && <span className="required">*</span> }
            </label> : "";
    }

    getInput() {

        const className = (this.props.className !== undefined) ? `form-control ${this.props.className}` : "form-control";
        if(this.props.type == "textarea") {
            return (
                <textarea className={className} placeholder={this.props.placeholder}
                          value={this.props.value} name={this.name} style={{height:this.props.height}} onChange={(event) => this.onChange(event)}></textarea>
            )
        } else {
            return (
                <input type={this.props.type} className={className} placeholder={this.props.placeholder}
                       value={this.props.value}  name={this.name} data-index={this.props.index} onChange={(event) => this.onChange(event)} />
            );
        }
    }

    onChange(e) {
        if(this.props.onChange) 
            this.props.onChange(this.name, e.target.value);

        this.setState({
            value: e.target.value
        });
    }

    render() {
        return (
            <div className="form-group">
                { this.getLabel() }
                <div className={"custom-input"}>
                    {
                        this.props.icon && (
                            <div className="input-group">
                                { this.getInput() }
                                <span className="input-group-addon">
                                    <i className={this.props.icon}></i>
                                </span>
                            </div>
                        )
                    }
                    {
                        !this.props.icon && (
                            this.getInput()
                        )
                    }
                </div>

            </div>
            )
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/FormInput.tsx